import * as React from "react";
import { RouteComponentProps, withRouter, NavLink } from "react-router-dom";
import {
  parseJwt,
  isTokenExpired,
} from "../../services/UtilService";
import {
  Stack,
  Callout,
  PrimaryButton,
  Persona,
  PersonaSize,
  PersonaInitialsColor,
  // DefaultButton, — 🚫 CHANGE PASSWORD
  ContextualMenu,
  Text,
  Dialog,
  Spinner,
  SpinnerSize,
} from "office-ui-fabric-react";
import "./navbar.css";
import { childrenGap, USER_ROLES } from "./Constants";
import {
  mdiLogout,
  mdiAccountCircleOutline,
  mdiMenu,
  // mdiLockReset, — 🚫 CHANGE PASSWORD
} from "@mdi/js";
import Icon from "@mdi/react";
import { THEME } from "../../utils/Styles";
import AdminLogo from "../../images/admin-logo.png";
import NabvarBgImage from "../../images/navbar-bg.png";
import moment from "moment";
import { logout } from "../../services/auth/AuthService";
// import { IPublicClientApplication } from "@azure/msal-browser";

const ADMIN_ROLE: any = {
  0: "Super Admin",
  1: "Datacenter Manager",
  2: "CEM",
  3: "Admin",
  4: "CEM Admin",
  5: "MIS",
};

export interface NavBarProps extends RouteComponentProps {
  width?: string;
  // msalInstance: IPublicClientApplication
}

export interface NavBarState {
  isCalloutVisible?: boolean;
  focusAccountMenu: boolean;
  isMenuVisible: boolean;
  isLoading: boolean;
}

class NavBar extends React.Component<NavBarProps, NavBarState> {
  _accountButtonElement: React.RefObject<any>;
  _menuButtonElement: React.RefObject<any>;
  constructor(props: NavBarProps) {
    super(props);
    this.state = { isCalloutVisible: false, focusAccountMenu: false, isMenuVisible: false, isLoading: false };
    this._accountButtonElement = React.createRef();
    this._menuButtonElement = React.createRef();
  }

  private _onAccountClicked = (event: React.MouseEvent<HTMLButtonElement>): void => {
    // Native keyboard/assistive activation has detail 0; pointer clicks do not.
    // Do not transfer stale post-login focus-visible state to Logout on a mouse click.
    const focusAccountMenu = event.detail === 0;
    this.setState(state => ({
      isCalloutVisible: !state.isCalloutVisible,
      focusAccountMenu,
    }));
  };

  private _onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false,
    });
  };
  handleLogout = async () => {
    this._onCalloutDismiss();

    this.setState({ isLoading: true });
    sessionStorage.clear();

    // App-only logout: clears this app's session + MSAL local cache and
    // redirects to /login?loggedout=1. Does NOT sign the user out of
    // Microsoft / the App Launcher, and suppresses silent SSO re-login.
    await logout("user");
  };

  _openMenuCallout = () => {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible,
    });
  };
  _closeMenuCallout = (): void => {
    this.setState({
      isMenuVisible: false,
    });
  };
  getMenuItems = () => {
    let tokenData = parseJwt();
    let menuItems = [
      {
        name: "Home",
        key: "home",
        onClick: () => {
          this.props.history.push("/");
          this._closeMenuCallout();
        },
      },
      {
        name: "MOM",
        key: "mom",
        onClick: () => {
          this.props.history.push("/customer-meetings");
          this._closeMenuCallout();
        },
      },
    ];

    if (
      // tokenData.isAdmin === true &&
      (tokenData.role === 0 || tokenData.role === 3 || tokenData.role === 1)
    ) {
      menuItems.push({
        name: "Data Centers",
        key: "datacenters",
        onClick: () => {
          this.props.history.push("/datacenters");
          this._closeMenuCallout();
        },
      });
    }

    if (tokenData.datacenterId) {
      menuItems.push({
        name: "Data Center",
        key: "datacenter",
        onClick: () => {
          this.props.history.push(`/datacenters/${tokenData.datacenterId}`);
          this._closeMenuCallout();
        },
      });
    }

    menuItems.push({
      name: "Customers",
      key: "customers",
      onClick: () => {
        this.props.history.push(
          `/customers?from=${0}&to=${12}&search=${""}&date=${moment()
            .subtract(1, "month")
            .format(
              "MM/DD/YYYY"
            )}&customerReportStatus=${10}&datacenterIds=${""}`
        );
        this._closeMenuCallout();
      },
    });

    if (tokenData.isAdmin === true && [0, 4].includes(tokenData.role)) {
      menuItems.push({
        name: "Admins",
        key: "admins",
        onClick: () => {
          this.props.history.push("/admins");
          this._closeMenuCallout();
        },
      });
    }

    if (tokenData.isAdmin === true && tokenData.role === 0) {
      menuItems.push({
        name: "System Configs",
        key: "system-configs",
        onClick: () => {
          this.props.history.push("/system-configs");
          this._closeMenuCallout();
        },
      });
      menuItems.push({
        name: "Audit Logs",
        key: "audit-logs",
        onClick: () => {
          this.props.history.push("/audit-logs");
          this._closeMenuCallout();
        },
      });
    }

    if (tokenData.isAdmin === true && [0, 4].includes(tokenData.role)) {
      menuItems.push({
        name: "SLA Matrix",
        key: "sla-matrixes",
        onClick: () => {
          this.props.history.push("/sla-matrixes");
          this._closeMenuCallout();
        },
      });
    }

    return menuItems;
  };

  // 🚫 CHANGE PASSWORD — self-service password change is disabled while Microsoft
  // SSO is the promoted sign-in path. Passwords are only for the emergency
  // fallback, so users have no routine reason to rotate one themselves.
  // See docs/SSO-LOGIN-POLICY.md.
  // changePassword = () => {
  //   this._onCalloutDismiss();
  //   this.props.history.push("/change-password");
  // };

  render() {
    const token = parseJwt();
    return (
      <React.Fragment>
        {this.state.isLoading && (
          <Dialog
            hidden={false}
            modalProps={{
              isBlocking: true,
              styles: { main: { maxWidth: 240 } },
              isModeless: false,
            }}
          >
            <Stack>
              <Spinner size={SpinnerSize.large} label="Logging out..." labelPosition="bottom" />
            </Stack>
          </Dialog>
        )}
        {!isTokenExpired() && (
          <header>
            <Stack
              className="custom-header overflow"
              horizontal
              horizontalAlign="space-between"
              verticalAlign="center"
            >
              <Stack.Item className="ms-hiddenXlUp nav-btn">
                <span
                  ref={this._menuButtonElement}
                  onClick={this._openMenuCallout}
                >
                  <Icon
                    path={mdiMenu}
                    size="32px"
                    style={{ marginTop: 4, padding: 8 }}
                    color={THEME.palette.white}
                  />
                </span>
              </Stack.Item>
              <Stack.Item styles={{ root: { zIndex: 9999, flexShrink: 0 } }}>
                <NavLink to="/" activeClassName="selected">
                  <img
                    className="logo-img"
                    src={"/logo.png"}
                    alt="STTGDC"
                    width={180}
                    height={44}
                  />
                </NavLink>
              </Stack.Item>
              <Stack.Item grow verticalFill className="ms-hiddenLgDown">
                <Stack
                  horizontal
                  verticalFill
                  verticalAlign="center"
                  horizontalAlign="end"
                >
                  <Stack.Item verticalFill className="nav-btn">
                    <NavLink
                      to="/"
                      activeClassName={window.location.pathname === "/" ? "selected" : ""}
                    >
                      Home
                    </NavLink>
                  </Stack.Item>
                  <Stack.Item verticalFill className="nav-btn">
                    <NavLink
                      to="/customer-meetings"
                      activeClassName={window.location.pathname === "/customer-meetings" ? "selected" : ""}
                    >
                      MOM
                    </NavLink>
                  </Stack.Item>
                  {
                    // token.isAdmin === true &&
                    (token.role === 0 || token.role === 3 || token.role === 1) && (
                      <Stack.Item verticalFill className="nav-btn">
                        <NavLink to="/datacenters" activeClassName="selected">
                          Data Centers
                        </NavLink>
                      </Stack.Item>
                    )}
                  {token.datacenterId && (
                    <Stack.Item verticalFill className="nav-btn">
                      <NavLink
                        to={`/datacenters/${token.datacenterId}`}
                        activeClassName="selected"
                      >
                        Data Center
                      </NavLink>
                    </Stack.Item>
                  )}
                  <Stack.Item verticalFill className="nav-btn">
                    <NavLink
                      to={`/customers?from=${0}&to=${12}&search=${""}&date=${moment()
                        .subtract(1, "month")
                        .format(
                          "MM/DD/YYYY"
                        )}&customerReportStatus=${10}&datacenterIds=${""}`}
                      activeClassName="selected"
                    >
                      Customers
                    </NavLink>
                  </Stack.Item>
                  {token.isAdmin === true && [0, 4].includes(token.role) && (
                    <Stack.Item verticalFill className="nav-btn">
                      <NavLink to={`/admins`} activeClassName="selected">
                        Admins
                      </NavLink>
                    </Stack.Item>
                  )}
                  {token.isAdmin === true && token.role === 0 && (
                    <Stack.Item verticalFill className="nav-btn">
                      <NavLink
                        to={`/system-configs`}
                        activeClassName="selected"
                      >
                        System Configs
                      </NavLink>
                    </Stack.Item>
                  )}
                  {token.isAdmin === true && token.role === 0 && (
                    <Stack.Item verticalFill className="nav-btn">
                      <NavLink to={`/audit-logs`} activeClassName="selected">
                        Audit Logs
                      </NavLink>
                    </Stack.Item>
                  )}
                  {token.isAdmin === true && [0, 4].includes(token.role) && (
                    <Stack.Item verticalFill className="nav-btn">
                      <NavLink to={`/sla-matrixes`} activeClassName="selected">
                        SLA Matrix
                      </NavLink>
                    </Stack.Item>
                  )}
                  <Stack.Item>
                    <div className="vertical-border"></div>
                  </Stack.Item>
                </Stack>
              </Stack.Item>

              <Stack.Item align="end" verticalFill className="nav-btn">
                <button
                  type="button"
                  className="profile-menu-trigger"
                  aria-label="Open user profile"
                  aria-haspopup="dialog"
                  aria-expanded={!!this.state.isCalloutVisible}
                  ref={this._accountButtonElement}
                  onClick={this._onAccountClicked}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  {/* <Icon
                    path={mdiAccountCircleOutline}
                    size={"32px"}
                    style={{ marginTop: 4, padding: 8 }}
                    color={THEME.palette.white}
                  /> */}
                  <img
                    src={AdminLogo}
                    alt="admin-logo"
                    className="admin-logo"
                  />
                  <Text className="admin-name">{token.name}</Text>
                </button>
                <div>
                  {this.state.isCalloutVisible && (
                    <Callout
                      styles={{ root: { width: 200, padding: 16 } }}
                      role="dialog"
                      aria-label="User profile"
                      gapSpace={10}
                      target={this._accountButtonElement.current}
                      onDismiss={this._onCalloutDismiss}
                      setInitialFocus={this.state.focusAccountMenu}
                    >
                      <Stack tokens={childrenGap}>
                        <Stack.Item>
                          <Persona
                            initialsColor={PersonaInitialsColor.purple}
                            text={token.name}
                            secondaryText={
                              token.isAdmin
                                ? ADMIN_ROLE[token.role]
                                : "Shift Manager"
                            }
                            size={PersonaSize.size48}
                          />
                        </Stack.Item>

                        {/* 🚫 CHANGE PASSWORD — see changePassword() above.
                        <Stack.Item>
                          <DefaultButton
                            onClick={this.changePassword}
                            styles={{ root: { width: "100%" } }}
                          >
                            <Icon
                              path={mdiLockReset}
                              size={"16px"}
                              color={THEME.palette.black}
                            />
                            &nbsp;&nbsp;Change Password
                          </DefaultButton>
                        </Stack.Item>
                        */}
                        <Stack.Item>
                          <PrimaryButton
                            className="profile-logout-button"
                            onClick={this.handleLogout}
                            styles={{ root: { width: "100%" } }}
                          >
                            <Icon
                              path={mdiLogout}
                              size={"16px"}
                              color={THEME.palette.white}
                            />
                            &nbsp;&nbsp;Logout
                          </PrimaryButton>
                        </Stack.Item>
                      </Stack>
                    </Callout>
                  )}
                </div>
              </Stack.Item>
              {/* <div className="navbar-bg-image">
                <img src={NabvarBgImage} alt="navbar-image" />
              </div> */}
            </Stack>
          </header>
        )}
        {/* : (
          <header>
            <Stack
              className="custom-header"
              horizontal
              verticalFill
              verticalAlign="center"
            >
              <Stack.Item align="stretch">
                <a href="/">
                  <img
                    className="logo-img"
                    src={"/logo.png"}
                    alt="STTGDC"
                  />
                </a>
              </Stack.Item>
            </Stack>
          </header>
        )} */}
        {this.state.isMenuVisible && (
          <ContextualMenu
            gapSpace={0}
            target={this._menuButtonElement.current}
            isBeakVisible={true}
            beakWidth={16}
            onDismiss={this._openMenuCallout}
            items={this.getMenuItems()}
          ></ContextualMenu>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(NavBar);
